export default {
  path: '/services',
  name: 'services',
  component: () => import('../components/service/Layout'),
  redirect: { name: 'ServiceList' },
  meta: {
    breadcrumb: 'service.services',
  },
  children: [
    {
      name: 'ServiceList',
      path: '',
      component: () => import('../views/service/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'ServiceCreate',
      path: 'new',
      component: () => import('../views/service/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'ServiceUpdate',
      path: ':id/edit',
      component: () => import('../views/service/Update'),
      meta: {
        breadcrumb: 'service.service',
      },
    },
    {
      name: 'ServiceShow',
      path: ':id',
      component: () => import('../views/service/Show'),
      meta: {
        breadcrumb: 'service.service',
      },
    }
  ]
};
